import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";



export const getblog = createAsyncThunk('getblog', async(data,{rejecteWithValue})=>{
    try {
        const response = await axiosInstance.get('/blog/getblog',data,{
            // headers:{
            //     'x-company-id': '67ce66294f28f85e4ff91e2c'
            // }
        })
        return response.data;
    } catch (error) {
        return rejecteWithValue(error.response?.data?.message || "An unexpected error occurred")
    }
});

const getblogslice = createSlice({name:'getblog',
    initialState:{
        loading:false,
        data:null,
        error:false,
        isError:false,
        isSucces:false,
    },reducers:{}
    ,extraReducers:(builder)=>{
        builder.addCase(getblog.pending, (state) => {
            state.loading = true;
            state.isError = false;
            state.isSucces = false;
            state.error = false;
            state.data = null;
          })
          .addCase(getblog.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.isError = false;
            state.error = false;
            state.isSucces = true;
          })
          .addCase(getblog.rejected, (state, action) => {
            state.loading = false;
            state.data = null;
            state.error = action.payload || action.error.message;
            state.isError = true;
            state.isSucces = false;
          });          
    }
});

export default getblogslice.reducer;